import React, { useEffect } from 'react';
import { Button, ButtonToolbar, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import validate from './Validate';
import renderField from '../../../shared/components/form/RenderField';

const EvaluationWayForm = (props) => {
  const { t, initialize, handleSubmit, backHandler, dto } = props;

  useEffect(() => {
    initialize(dto);
  }, [dto]);

  return (
    <form className="form" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">{t('general.name')}</span>
        <div className="form__form-group-field">
          <Field
            name="name"
            type="text"
            component={renderField}
            maxLength="50"
            placeholder={t('placeholder.evaluation-way.name')}
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('general.description')}
        </span>
        <div className="form__form-group-field">
          <Field
            name="description"
            type="text"
            component="textarea"
            maxLength="500"
            placeholder={t('placeholder.evaluation-way.description')}
          />
        </div>
      </div>
      <div className="form__form-group">
        <div className="form__form-group-field">
          <Label className="generic__label"> {t('general.active')} </Label>
          <Field
            name="active"
            component={renderCheckBoxField}
            className="colored-click"
          />
        </div>
      </div>
      <ButtonToolbar className="form__button-toolbar">
        <Button color="primary" onClick={backHandler}>
          {t('general.back')}
        </Button>
        <Button color="success" type="submit">
          {t('general.save')}
        </Button>
      </ButtonToolbar>
    </form>
  );
};

EvaluationWayForm.propTypes = {
  t: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  dto: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    active: PropTypes.bool,
  }).isRequired,
};

export default withTranslation('common')(
  reduxForm({
    form: 'EvaluationWayForm',
    validate,
  })(EvaluationWayForm)
);
